// requires a "." with 2-3 character extension.
export const emailValidatorRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

// match the payroll grid and preview routes. /client/{clientCode}/payroll/{year}/{seqNo}
export const payrollGridRouteRegex = /\/([\w\d]){6}\/payroll\/[\d]{4}\/[\d]+/;
export const payrollPreviewRouteRegex = /\/([\w\d]){6}\/payroll-preview\/[\d]{4}\/[\d]+/;
export const manualPayrollRouteRegex = /\/([\w\d]){6}\/manual-payroll\/[\d]{4}\/[\d]+/;
export const manualPayrollPreviewRouteRegex =
  /\/([\w\d]){6}\/manual-payroll-preview\/[\d]{4}\/[\d]+/;

export const correctionPayrollRouteRegex = /\/([\w\d]){6}\/payroll-corrections[/]?$/;
export const correctionPayrollDetailRouteRegex =
  /\/([\w\d]){6}\/payroll-corrections\/[\d]{4}\/[\d]+\/person\/[\d]+\/[\d]+/;
export const correctionPayrollPreviewRouteRegex =
  /\/([\w\d]){6}\/payroll-corrections-preview\/[\d]{4}\/[\d]+/;

export const addNewPersonRouteRegex = /\/([\w\d]){6}\/person\/add+/;
export const payrollCacheKeyRegex = /payroll-([\w\d]){6}-([\d]){4}-[\d]+/;
